import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const PaymentList = () => {
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    vendor_type_id: "",
    vendor_id: "",
  });
    const navigate = useNavigate();

  const [payments, setPayments] = useState([]);
  const [vendorTypes, setVendorTypes] = useState([]);
  const [vendors, setVendors] = useState([]);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    borderTop: "1px solid black",
    textAlign: "center",
  };

 /* ---------------- FETCH DROPDOWNS ---------------- */

const fetchVendorTypes = async () => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorTypesList`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setVendorTypes(res.data.data || []);
  } catch (error) {
    if (handle401(error)) return;
    console.error("Fetch vendor types error", error);
  }
};

const fetchVendors = async (vendorTypeId) => {
  try {
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/vendorsList`,
      { vendor_type_id: vendorTypeId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setVendors(res.data.data || []);
  } catch (error) {
    if (handle401(error)) return;
    console.error("Fetch vendors error", error);
  }
};

/* ---------------- FETCH PAYMENT LIST ---------------- */

const fetchPayments = async (pageNo = 1, filterValues = filters, perPageValue = perPage) => {
  try {
    setLoading(true);
const token = localStorage.getItem("token");

    const payload = {
  vendor_type_id: filterValues.vendor_type_id || "",
  vendor_id: filterValues.vendor_id || "",
  page: pageNo,
  per_page: perPageValue,
};

    const res = await axios.post(
      `${BASE_URL}/paymentsList`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setPayments(res.data.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
  Math.ceil((res.data.total_records || 0) / (res.data.per_page || perPageValue))
);

  } catch (error) {
    if (handle401(error)) return;
    console.error("Payment List Error", error);
  } finally {
    setLoading(false);
  }
};




const handleViewDetails = (vendorId) => {
  console.log("Vendor ID clicked:", vendorId);
  navigate(`/app/payment-details/${vendorId}`);
};

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD/MM/YYYY
};

  /* ---------------- PAGINATION NUMBERS ---------------- */

  const getPageNumbers = () => {
    const pages = [];
    const max = 5;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + max - 1);

    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  /* ---------------- EFFECTS ---------------- */

  useEffect(() => {
    fetchVendorTypes();
    fetchPayments(1);
  }, []);

  useEffect(() => {
    if (filters.vendor_type_id) {
      fetchVendors(filters.vendor_type_id);
    } else {
      setVendors([]);
      setFilters({ ...filters, vendor_id: "" });
    }
  }, [filters.vendor_type_id]);

  useEffect(() => {
    fetchPayments(1);
  }, [perPage]);

  /* ---------------- UI ---------------- */

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* 🔷 SEARCH CARD */}
      <Card className="mb-4 border-0" style={{
    background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
    borderRadius: "14px",
    boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
  }}>
        <div className="px-4 py-3 text-white" style={{ background: "linear-gradient(90deg,#0D47A1,#1565C1)" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter me-2"></i> Job Worker Payment List
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            {/* Vendor Type */}

            {/* Vendor Type */}
<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Organisation Type</Form.Label>
    <Form.Select
      value={filters.vendor_type_id}
      onChange={(e) => {
        const vendorTypeId = e.target.value;

        setFilters({ vendor_type_id: vendorTypeId, vendor_id: "" });

        // Fetch vendors for selected type
        if (vendorTypeId) {
          fetchVendors(vendorTypeId);
        } else {
          setVendors([]);
        }


      }}
      style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
    >
      <option value="">Select Organisation Type</option>
      {vendorTypes.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendor_type_name} ({v.vendor_type_short_name})
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

{/* Vendor */}
<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Organisation</Form.Label>
    <Form.Select
      value={filters.vendor_id}
      onChange={(e) => {
        const vendorId = e.target.value;
        setFilters({ ...filters, vendor_id: vendorId });

      }}
      style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
      disabled={!filters.vendor_type_id || vendors.length === 0}
    >
      <option value="">Select Organisation</option>
      {vendors.map((v) => (
        <option key={v.id} value={v.id}>
          {v.vendors_master_name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>

{/* Record Showing */}
<Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>
    <Form.Select
      value={perPage}
      onChange={(e) => {
        const value = Number(e.target.value);
        setPerPage(value);
        setPage(1);

        // Reload table with new perPage
        fetchPayments(1);
      }}
      style={{ borderRadius: "10px", border: "2px solid #1565C1" }}
    >
      <option value={10}>10 Per Page</option>
      <option value={25}>25 Per Page</option>
      <option value={50}>50 Per Page</option>
      <option value={100}>100 Per Page</option>
    </Form.Select>
  </Form.Group>
</Col>

{/* Search & Reset Buttons */}
<Col md={3} className="d-flex gap-3 mt-3">
  <Button
    className="w-50 fw-semibold text-white"
    style={{ background: "#1565C1", border: "none", borderRadius: "10px" }}
    onClick={() => fetchPayments(1)}
  >
    <i className="fa-solid fa-magnifying-glass me-2"></i> Search
  </Button>

  <Button
  className="w-50 fw-semibold text-white"
  style={{ background: "#E53935", border: "none", borderRadius: "10px" }}
  onClick={() => {
    const resetFilters = { vendor_type_id: "", vendor_id: "" };

    setFilters(resetFilters);
    setVendors([]);
    setPage(1);
    setPerPage(10);
    fetchPayments(1, resetFilters, 10);
  }}
>
  <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
</Button>

</Col>



          </Row>
        </Card.Body>
      </Card>

      {/* TABLE */}
      <Card className="border-0 shadow">
        <Table bordered hover responsive striped>
          <thead>
            <tr>
              <th style={theadStyle}>SL</th>
              {/* <th style={theadStyle}>Vendor Type</th> */}
              <th style={theadStyle}>Organisation</th>
              <th style={theadStyle}>Date</th>
              <th style={theadStyle}>Type</th>
              {/* <th style={theadStyle}>Amount</th> */}
              <th style={theadStyle}>Balance</th>
              <th style={theadStyle}>Ledger</th>
              <th style={theadStyle}>Action</th>

            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr><td colSpan="9" className="text-center">Loading...</td></tr>
            ) : payments.length > 0 ? (
              payments.map((row, index) => (
                <tr key={row.id}>
                  <td className="text-center">{(page - 1) * perPage + index + 1}</td>
                  {/* <td className="text-center">{row.vendor_type_short_name}</td> */}
                  <td className="text-center">{row.vendors_master_name} ({row.vendor_type_short_name})</td>
                  <td className="text-center"> {formatDate(row.payment_date)}</td>
                  <td className="text-center">{row.type}</td>

                  <td className="text-center">₹ {row.balance}</td>


                <td className="text-center">
                    <button
                        className="btn btn-sm btn-info text-white"
                        title="View Details"
                        onClick={() => handleViewDetails(row.vendor_id)}
                    >
                        <i className="fa-solid fa-eye"></i>
                    </button>
                </td>
                <td className="text-center">
                    <button
                        className="btn btn-sm btn-success text-white"
                        title="View Details"
                        onClick={() =>
                              Swal.fire(
                                "Information",
                                "This facility will be available soon.",
                                "info"
                              )
                            }
                    >
                        Pay
                    </button>
                </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="9" className="text-center text-muted">No Data Found</td></tr>
            )}
          </tbody>
        </Table>

        {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <ul className="pagination">
            <li className={`page-item ${page === 1 && "disabled"}`}>
              <button className="page-link" onClick={() => fetchPayments(page - 1)}>‹</button>
            </li>
            {getPageNumbers().map((p) => (
              <li key={p} className={`page-item ${page === p && "active"}`}>
                <button className="page-link" onClick={() => fetchPayments(p)}>{p}</button>
              </li>
            ))}
            <li className={`page-item ${page === totalPages && "disabled"}`}>
              <button className="page-link" onClick={() => fetchPayments(page + 1)}>›</button>
            </li>
          </ul>
        </div>
      )}
      </Card>


    </div>
  );
};

export default PaymentList;
